module.exports = __webpack_public_path__ + "static/media/tooltip-icon.32b3a9ba.svg";